import { useMemo } from 'react';

import { useAccountContext } from '~/providers/AccountProvider';

export const useIsAirEmail = () => {
  const { data: account } = useAccountContext();

  const isAirEmail = useMemo(() => {
    return account?.email.endsWith('@air.inc');
  }, [account?.email]);

  return { isAirEmail };
};
